(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("FileUpload", [], factory);
	else if(typeof exports === 'object')
		exports["FileUpload"] = factory();
	else
		root["FileUpload"] = factory();
})(this, function() {
return 